module.exports = __webpack_public_path__ + "img/count_down3.c454083c.png";